import { SalesInvoiceDetailPage } from "@/features/sales-invoice/pages/SalesInvoiceDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-invoice/$id/detail")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["sales_invoice.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesInvoiceDetailPage,
});
